import React, { useRef, useEffect } from 'react';
import { bool, node, objectOf, string } from 'prop-types';

import Loading from './components/Loading';

function LoadingWrapper({ loading, children, withInitialLoading, loadingProps, className }) {
  const initialLoading = useRef(withInitialLoading);
  useEffect(() => {
    if (initialLoading.current && loading) {
      initialLoading.current = false;
    }
  }, [loading]);
  return initialLoading.current || loading ? (
    <Loading className={className} {...loadingProps} />
  ) : (
    <>{children}</>
  );
}

LoadingWrapper.propTypes = {
  children: node,
  className: string,
  loading: bool,
  loadingProps: objectOf(string),
  withInitialLoading: bool
};

LoadingWrapper.defaultProps = {
  className: '',
  withInitialLoading: false
};

export default LoadingWrapper;
